import React, { FC, useCallback, PropsWithChildren } from "react";
import "./ChatMessageBubble.scss";

export type MessageOwnership = "mine" | "others";

export interface Props {
    readonly owner: MessageOwnership;
    readonly hasTail?: boolean;
    onClick?(): void;
}

function getTailSvgPath(owner: MessageOwnership): string {
    if (owner === "others") {
        return "m 80 0 v 240 h -60 c 40 -40 60 -160 60 -240";
    }
    return "m 0 0 v 240 h 60 c -40 -40 -60 -160 -60 -240";
}

function getTailSvg(owner: MessageOwnership) {
    return (
        <svg className="chat-text-bubble__tail" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 240">
            <path d={getTailSvgPath(owner)} fill="currentColor" />
        </svg>
    );
}

const ChatMessageBubble: FC<PropsWithChildren<Props>> = props => {
    const { owner, onClick } = props;

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick();
        }
    }, [onClick]);

    return (
        <div
            onClick={handleClick}
            className={`chat-text-bubble ${owner === "mine" ? "chat-text-bubble--mine" : "chat-text-bubble--others"}`}>
            {(props.hasTail) && getTailSvg(owner)}
            {props.children}
        </div>
    );
}

export default ChatMessageBubble;
